<template>
    <div>
        <div class="container container-mob " >
            <p style="color: black; text-align: left; font-size: 2em; font-weight:bold">
                <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад" class="mr-2">
                    <img width="40px" src="/static/images/icons/left-arrow.svg">
                </b-button>
                {{$t('message.private_schools')}}</p>
        </div>
        <div class="container" >
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/">{{$t('message.main_page')}}</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t('message.private_schools')}}</li>
                </ol>
            </nav>
            <hr>
            <div class="col-md-6 offset-md-6 pb-3">
                <div class=" form-row">
                    <div class="col">
                        <b-form-select v-model="selected_city" @change="fetchPrivateSchools">
                            <option :value="null">{{$t('message.select_region')}}</option>
                            <option v-for="item in city" :key="item.id" :value="item.id">{{item['city_'+selectedLocale.suffix.toLowerCase()]}}</option>
                        </b-form-select>
                    </div>
                    <div class="col">
                        <b-form-select v-model="selected_region" @change="fetchPrivateSchools">
                            <option :value="null">{{$t('message.select_district')}}</option>
                            <option v-for="item in sorted_region" :key="item.id" :value="item.id">{{item['region_'+selectedLocale.suffix.toLowerCase()]}}</option>
                        </b-form-select>
                    </div>
                </div>
            </div>
            <b-card-group columns>
                <b-card v-for="item in schools" v-bind:key="item.id" :img-src="(item.photo) ? '/static/uploads/'+item.photo: '/static/images/no_image.jpg'"  img-height="168" img-alt="Image"  img-top>
                    <b-card-title><b>{{item['name_'+selectedLocale.suffix.toLowerCase()]}}</b></b-card-title>
                    <b-card-text>
                        <b>{{$t('message.language_of_instruction')}}: </b> {{item.langs}}
                    </b-card-text>
                    <hr/>
                    <div class="row">
                        <div class="col-6">
                            <small class="mb-0 p-b-10 font-weight-bold">{{$t('message.training_duration_1')}}</small>
                            <br/><small class="mt-0 p-t-10">{{item.duration}}</small>
                        </div>
                        <div class="col-6">
                            <small class="mb-0 p-b-10 font-weight-bold">{{$t('message.district')}}</small><br/>
                            <small class="mt-0 p-t-10">{{findRegion(item.region)}}</small>
                        </div>
                    </div>
                    <template v-slot:footer>
                        <b-col lg="12" class="text-center">
                            <router-link :to="'/privet-school/'+item.school_id"><b-button variant="primary" >{{$t('message.more_info')}}</b-button></router-link>
                        </b-col>
                    </template>
                </b-card>

            </b-card-group>
            <div class=" py-3">
               <!-- <b-pagination
                        total-rows="3"
                        per-page="1"
                        aria-controls="my-table"
                        align="center"
                ></b-pagination>-->
            </div>

            <div v-if="schools.length === 0" class="text-center">
                <img src="/static/images/nodatafound.png" width="100%"/>
                       <h2 class="">{{$t('message.notfound')}}</h2>

            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {getPrivateSchools, getCity, getRegion} from '../api/index'

    export default {
        name: 'privet-schools',
        data() {
            return {
                selected_region: null,
                selected_city: null,
                sorted_region: [],
                city: [],
                region: [],
                schools: []
            }
        },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        watch: {
            selected_city: function (val) {
                this.selected_region = null
                this.sorted_region = this.region.filter(function (item) {
                    return val * 1 === item.city_id * 1;
                })
            }
        },
        mounted() {
            this.getData()
            this.fetchPrivateSchools()
        },
        methods: {
            getData() {
                getCity().then(res => {
                    this.city = res.data
                })
                getRegion().then(res => {
                    this.region = res.data
                })
            },
            fetchPrivateSchools() {

                var reg = []
                if (!this.selected_region) {
                    this.sorted_region.map(value => {
                        reg.push(value.id)
                    })
                }else {
                    reg = this.selected_region
                }
                var query = {
                    region: reg.toString()
                }
                this.schools = []

                if(this.sorted_region.length || !this.selected_city) {
                    getPrivateSchools(query).then(res => {
                        this.schools = res.data
                    })
                }

            },
            findRegion(id) {
                var filtered = this.region.filter(function(item) {
                    return item.id *1 === id*1;
                });
                return (filtered.length) ? filtered[0]['region_'+this.selectedLocale.suffix.toLowerCase()] : null;
            }
        }
    }
</script>

<style>
    .container-mob {
        padding-top: 100px;
        display: flex;
    }
</style>
